/**
 * Voltron analytics triggers for the Lists widget clicks (tile and View All).
 * `widgetTemplates` stays "workspace dashboard": the Voltron listener overrides it on the account
 * dashboard and keeps it everywhere else. Label strings are pending AAPE confirmation.
 */
export const VIEW_ALL_LISTS_EVENT = 'user-lists-carousel.viewAllLists';
export const VIEW_SELECTED_LISTS_EVENT = 'user-lists-carousel.viewSelectedLists';

const WIDGET_TEMPLATES = 'workspace dashboard';
const VIEW_ALL_CAMPAIGN = 'view all';
const LIST_NAME_CAMPAIGN = 'list name';
const LIST_IMAGE_CAMPAIGN = 'list image';

const trigger = (event, payload) => {
  // eslint-disable-next-line no-undef
  const lifeCycleEventBus = globalThis.window?.LIFE_CYCLE_EVENT_BUS;
  if (lifeCycleEventBus) {
    lifeCycleEventBus.trigger(event, payload);
  }
};

export const trackViewAllClick = () => {
  trigger(VIEW_ALL_LISTS_EVENT, {
    widgetTemplates: WIDGET_TEMPLATES,
    widgetCampaign: VIEW_ALL_CAMPAIGN,
    widgetComponent: '0'
  });
};

/**
 * @param {number} position - 0-based tile index, reported 1-based.
 * @param {'name'|'image'} source - which ListTile link was clicked.
 */
export const trackListTileClick = (position, source) => {
  trigger(VIEW_SELECTED_LISTS_EVENT, {
    widgetTemplates: WIDGET_TEMPLATES,
    widgetCampaign: source === 'image' ? LIST_IMAGE_CAMPAIGN : LIST_NAME_CAMPAIGN,
    widgetComponent: String(position + 1)
  });
};
